import React from 'react';

export interface LanguageIndicatorProps {
  language: string;
  className?: string;
}

export const LanguageIndicator: React.FC<LanguageIndicatorProps> = ({
  language,
  className = ''
}) => {
  return (
    <div className={`absolute top-2 left-4 z-10 ${className}`}>
      <span className="text-xs font-medium text-slate-400 bg-slate-800/50 px-2 py-1 rounded backdrop-blur-sm border border-slate-700/50">
        {language}
      </span>
    </div>
  );
};

export default LanguageIndicator;